import { css, cx } from '@emotion/css';
import { NumericFormat } from 'react-number-format';

interface PercentageFieldProps {
  value?: number;
  fixedDecimals?: number;
  color?: string;
  className?: string;
}

const percentageFieldStyle = (color?: string) => css`
  color: ${color ?? 'inherit'};
`;

export const PercentageField = ({ value, fixedDecimals = 3, color, className }: PercentageFieldProps) => {
  return (
    <NumericFormat
      value={value?.toFixed(fixedDecimals) || 0}
      displayType={'text'}
      decimalScale={fixedDecimals}
      className={cx(percentageFieldStyle(color), className)}
      suffix={'%'}
      prefix={value && value >= 0 ? '+' : ''}
    />
  );
};
